export default {
      id: "LWS-dotted-usage",
      viewBox: "0 0 150 32",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#LWS-dotted",
      toString: function () {
        return this.url;
      }
    }